var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldShuffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.74 17.92c-.01-.08-.02-.16-.05-.23a.913.913 0 0 0-.15-.23c0-.006-.003-.01-.01-.01a.776.776 0 0 0-.53-.22l-4.67.02h-.01c-.6 0-1.18-.28-1.54-.76l-1.22-1.57a.738.738 0 0 0-1.05-.13.74.74 0 0 0-.13 1.05l1.22 1.57c.65.84 1.67 1.34 2.73 1.34h.01l2.85-.01-.71.71c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l2-2c.07-.07.12-.15.16-.24.03-.1.05-.2.05-.29 0-.02-.01-.04-.01-.06zM5.62 5.262H5.6l-2.6.01c-.41 0-.75.34-.75.75s.34.75.75.75l2.61-.01h.01c.63 0 1.22.3 1.58.81l1.08 1.5c.15.2.38.31.61.31.15 0 .31-.05.44-.14.34-.25.41-.72.17-1.05l-1.08-1.5a3.45 3.45 0 0 0-2.8-1.43zM21.75 6.029a.776.776 0 0 0-.22-.53l-2-2a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l.71.71-2.73-.01h-.02c-1.15 0-2.23.57-2.87 1.54l-6.39 9.58c-.36.54-.97.87-1.62.87h-.01L3 17.229a.749.749 0 1 0 0 1.5l2.55.01h.02c1.16 0 2.23-.57 2.87-1.54l6.39-9.58c.36-.54.97-.87 1.62-.87h.01l4.54.02a.753.753 0 0 0 .54-.23c.06-.07.12-.14.15-.23.03-.07.04-.15.05-.23 0-.02.01-.04.01-.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldShuffle);
export default __webpack_public_path__ + "static/media/vuesax-bold-shuffle.a2221b2b73afb5db7035d99b371c8527.svg";
export { ForwardRef as ReactComponent };